import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Button from '@material-ui/core/Button';
import styled from 'styled-components';
import AgGrid from '@components/AgGrid/AgGrid';

import _ from 'lodash';

import { fetchingState } from '@constants';
import * as globalActions from '../../actions/global';
import * as exemptionActions from '../../actions/exemption';
import { applicationLookupModes } from '../../constants';
import selector from './selector';

const ApplicationLookupModal = ({
  closeModal,
  data,
  fetchPreference,
  lookupApplication,
  modalOpen,
  mode,
  preference,
  propertyId,
  selectApplications,
  state,
  userData,
}) => {
  const agGridApi = useRef();

  useEffect(() => {
    if (!propertyId) {
      return;
    }

    fetchPreference({
      userId: userData.get('id'),
    });
    lookupApplication({ propertyId });
  }, [propertyId]);

  const buildColumnDefs = () => {
    let columnDefs =
      mode === applicationLookupModes.singleSelection
        ? []
        : [
            {
              field: 'select',
              headerName: '',
              checkboxSelection: true,
              width: 90,
            },
          ];

    columnDefs = columnDefs.concat([
      { headerName: 'Applicant', field: 'applicantName' },
      { headerName: 'Type', field: 'applicantIDType' },
      { headerName: 'ID', field: 'applicantIDNum' },
      { headerName: 'Birthday', field: 'applicantBirthDt' },
      { headerName: 'Co-Applicant', field: 'coApplicantName' },
      { headerName: 'Co-Applicant Type', field: 'coApplicantIDType' },
      { headerName: 'Co-Applicant ID', field: 'coApplicantIDNum' },
      { headerName: 'Co-Applicant Birthday', field: 'coApplicantBirthDt' },
    ]);

    return columnDefs;
  };

  const buildRowData = () =>
    data &&
    data.toJS() &&
    data
      .toJS()
      .map(row =>
        _.pick(row, [
          'applicationID',
          'applicantName',
          'applicantIDType',
          'applicantIDNum',
          'applicantBirthDt',
          'coApplicantName',
          'coApplicantIDType',
          'coApplicantIDNum',
          'coApplicantBirthDt',
        ]),
      );

  const submitValues = () => {
    const applications = agGridApi.current.getSelectedRows().map(row => ({
      applicationID: row.applicationID,
    }));
    selectApplications(applications);
    closeModal();
  };

  return (
    <Dialog fullWidth maxWidth="md" open={modalOpen} onClose={closeModal}>
      <DialogTitle id="form-dialog-title">
        Application Lookup
        <CloseButton onClick={closeModal}>
          <CloseIcon />
        </CloseButton>
      </DialogTitle>
      <DialogContent style={{ paddingBottom: 0 }}>
        <TableContainer className="ag-theme-material">
          {state === fetchingState.FETCHING ? (
            <div style={{ textAlign: 'center' }}>
              <CircularProgress />
            </div>
          ) : (
            <AgGrid
              name="applicationLookup"
              columnDefs={buildColumnDefs()}
              rowData={buildRowData() || []}
              fetchPreference={fetchPreference}
              preference={preference}
              rowSelection={
                mode === applicationLookupModes.singleSelection
                  ? 'single'
                  : 'multiple'
              }
              rowMultiSelectWithClick={
                mode === applicationLookupModes.multiSelection
              }
              onGridReady={params => {
                params.api.sizeColumnsToFit();
                agGridApi.current = params.api;
              }}
            />
          )}
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeModal} color="primary">
          Cancel
        </Button>
        <Button onClick={submitValues} color="primary">
          Select
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ApplicationLookupModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  data: ImmutablePropTypes.list,
  fetchPreference: PropTypes.func.isRequired,
  lookupApplication: PropTypes.func.isRequired,
  modalOpen: PropTypes.bool.isRequired,
  mode: PropTypes.number,
  preference: PropTypes.object,
  propertyId: PropTypes.number,
  selectApplications: PropTypes.func.isRequired,
  state: PropTypes.string,
  userData: ImmutablePropTypes.map,
};

ApplicationLookupModal.defaultProps = {
  mode: 0,
};

const CloseButton = styled(IconButton)`
  &&& {
    position: absolute;
    right: 10px;
    top: 10px;
    color: #888;
  }
`;

const TableContainer = styled.div`
  height: 250px;
  margin: 10px 4px 4px 4px;
`;

const mapDispatchToProps = dispatch => ({
  fetchPreference: bindActionCreators(globalActions.fetchPreference, dispatch),
  lookupApplication: bindActionCreators(
    exemptionActions.lookupApplication,
    dispatch,
  ),
  selectApplications: bindActionCreators(
    exemptionActions.applicationLookupModalSelectRecords,
    dispatch,
  ),
  closeModal: bindActionCreators(
    exemptionActions.closeApplicationLookupModal,
    dispatch,
  ),
});

export default connect(
  selector,
  mapDispatchToProps,
)(ApplicationLookupModal);
